export default __webpack_public_path__ + "static/media/003.41b39de6.png";